import React from 'react';

import createEmojiPlugin from './DraftJSPlugins/draft-js-emoji-plugin/src';

export const useEmojiPlugin = ({ enable, isRtl }: { enable: boolean; isRtl: boolean }) => {
  const [emojiSuggestionsOpen, setEmojiSuggestionsOpen] = React.useState(false);

  const emojiPlugin = React.useMemo(() => {
    return enable ? createEmojiPlugin({ useNativeArt: true }) : undefined;
  }, [enable]);

  const { EmojiSelect, EmojiSuggestions } = emojiPlugin ?? {
    EmojiSelect: null,
    EmojiSuggestions: null,
  };

  const onOpeningEmojiSuggestion = React.useCallback((open: boolean) => {
    setEmojiSuggestionsOpen(open);
  }, []);

  const emojiButton = React.useMemo(() => {
    if (!enable || !EmojiSelect || !EmojiSuggestions) {
      return null;
    }

    return <EmojiSelect isRtl={isRtl} emojiSuggestionsEnabled />;
  }, [enable, EmojiSelect, EmojiSuggestions, isRtl]);

  const emojiSuggestions = React.useMemo(() => {
    if (!enable || !EmojiSelect || !EmojiSuggestions) {
      return null;
    }

    return <EmojiSuggestions onOpeningSuggestion={onOpeningEmojiSuggestion} suggestionsOnTop />;
  }, [enable, EmojiSelect, EmojiSuggestions, onOpeningEmojiSuggestion]);

  return {
    emojiPlugin,
    emojiButton,
    emojiSuggestionsOpen,
    emojiSuggestions,
  };
};
